export const makeOrgAssetLink = (id: number) => {
  // use the proxied api url in local dev mode
  // because otherwise the link will show localhost:3000
  return `${
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_PROXIED_API_URL
      : process.env.REACT_APP_API_URL
  }/p1/resources/${id}/view`
}
